import styled from "styled-components";

export const StyledImg = styled.img`
    display: block;
    position: relative;

    object-fit: cover;

    width: 100%;
    height: 100%;
`;
